// Define only types we explicitely support
export var AlgoTransactionType;
(function (AlgoTransactionType) {
    AlgoTransactionType["PAYMENT"] = "pay";
    AlgoTransactionType["ASSET_TRANSFER"] = "axfer";
})(AlgoTransactionType || (AlgoTransactionType = {}));
//# sourceMappingURL=indexer.types.js.map